import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Project extends Component {
    constructor(props){
        super(props);
        this.state = {
            data: [
                {
                    id: 1,
                    srcimg: 'assets/img/project/project-1-440x280.jpeg',
                    heading: 'PLYWOOD & BLOCKBOARDS',
                    meta: 'Building Materials',
                    text: 'Wood Products'
                },
                {
                    id: 2,
                    srcimg: 'assets/img/project/project-2-440x280.jpeg',
                    heading: 'HARDWARE & TOOLS',
                    meta: 'Construction Tools',
                    text: 'Professional Grade'
                },
                {
                    id: 3,
                    srcimg: 'assets/img/project/project-3-440x280.png',
                    heading: 'MDF LAMINATE SAMPLES',
                    meta: 'Finishing Materials',
                    text: 'Wide Color Range'
                },
                {
                    id: 4,
                    srcimg: 'assets/img/project/project-4-440x280.jpeg',
                    heading: 'PREMIUM BOARDS STOCK',
                    meta: 'Bulk Supply',
                    text: 'Large Inventory'
                },
                {
                    id: 5,
                    srcimg: 'assets/img/project/project-5-440x280.jpeg',
                    heading: 'STOREFRONT DISPLAY',
                    meta: 'Retail Shop',
                    text: 'Nairobi Location'
                },
                {
                    id: 6,
                    srcimg: 'assets/img/project/project-6-440x280.jpeg',
                    heading: 'INTERIOR PRODUCTS',
                    meta: 'Hardware Store',
                    text: 'Complete Solutions'
                },
                {
                    id: 7,
                    srcimg: 'assets/img/project/project-7-440x280.jpeg',
                    heading: 'COLOR SELECTION GUIDE',
                    meta: 'MDF Laminates',
                    text: 'Design Options'
                },
                {
                    id: 8,
                    srcimg: 'assets/img/project/project-8-440x280.jpeg',
                    heading: 'ADHESIVES & CHEMICALS',
                    meta: 'Cona Products',
                    text: 'Quality Brands'
                }
            ]
        }
    }
    render() {
        return (
            <div className="themesflat-carousel-box clearfix" data-gap={30} data-column={4} data-column2={2} data-column3={1}
                data-auto="false">
                <div className="owl-carousel owl-theme">
                    {
                        this.state.data.map(data => (
                            <div className="themesflat-project style-1 data-effect  clearfix" key={data.id}>
                                <div className="project-item">
                                    <div className="inner">
                                        <div className="thumb data-effect-item has-effect-icon w40 offset-v-43 offset-h-46">
                                            <img src={data.srcimg} alt="altimage" />
                                            <div className="text-wrap text-center">
                                                <h5 className="heading"><Link to="#">{data.heading}</Link></h5>
                                                <div className="elm-meta">
                                                    <span>
                                                        <Link to="#">{data.meta}</Link></span>
                                                    <span>
                                                        <Link to="#">{data.text}</Link></span>
                                                </div>
                                            </div>
                                            <div className="elm-link">
                                                <Link to="#" className="icon-1 icon-search"></Link>
                                                <Link to="#" className="icon-1"></Link>
                                            </div>
                                            <div className="overlay-effect bg-color-3" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        );
    }
}

export default Project;